import { render, staticRenderFns } from "./EventUnit.vue?vue&type=template&id=44a91c42&"
import script from "./EventUnit.vue?vue&type=script&lang=js&"
export * from "./EventUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports